import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getData } from '../helpers/api';

export default function AuthenticateAllow({Component, role}) {
    const user = useSelector(state => state.user)
    const dispatch = useDispatch()

    const token = localStorage.getItem('token')
    useEffect(() => {
        if (token && !user._id) {
            getData(`${process.env.REACT_APP_APP_API_URL}/api/user`).then(res => {
                res.data.user.token = token
                dispatch({
                    type: 'LOGIN_USER',
                    user: res.data.user
                });
                dispatch({
                    type: 'USER_ORDERS',
                    orders: res.data.orders,
                });
            }).catch(console.log);
        }
    }, [user]);
    return Component
}